import React from 'react';
import ReactDom from 'react-dom';
import { Link, useHistory, useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { SiteConfigManager, useUserMessages } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';
import { Icon, Loader } from '@atlas/ui';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const { messages: messagesPath } = clientProfileRoutes;

const Message = () => {
  const { messageId } = useParams();
  const { push } = useHistory();
  const { getUnreadMessages, markMessageAsRead, messages } = useUserMessages();
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const selectedMessage = React.useMemo(
    () => messages.find(({ id }) => id === messageId),
    [messageId, messages],
  );

  React.useEffect(() => {
    if (!selectedMessage) {
      push(`${clientProfilePath}/${messagesPath}`);
    }
  }, [clientProfilePath, push, selectedMessage]);

  React.useEffect(() => {
    if (selectedMessage && !selectedMessage.read) {
      markMessageAsRead(messageId);
      getUnreadMessages();
    }
  }, [getUnreadMessages, markMessageAsRead, messageId, selectedMessage]);

  if (!selectedMessage) {
    return (
      <div className="message-loader">
        <Loader className="absolute" />
      </div>
    );
  }

  const formattedDate = dayjs(selectedMessage.createTime).format('DD/MM/YYYY');

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <div className="message-page">
        <Link className="back-to-container" to={messagesPath}>
          <Icon className="icon-back" name="back" />
          <span className="title-text">{selectedMessage.subject}</span>
        </Link>
        <div className="message">
          <p
            className="message-body"
            dangerouslySetInnerHTML={{ __html: selectedMessage.messageBody }}
          />
          <p className="message-date">{formattedDate}</p>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Message;
